import { Draggable } from 'components/Draggable'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { AnnotationMenu } from 'features/kestrelViewer/ui/popupMenu/annotationMenu/AnnotationMenu'
import { CloseButton } from 'features/kestrelViewer/ui/popupMenu/CloseButton'
import { PolygonMenu } from 'features/kestrelViewer/ui/popupMenu/polygonMenu/PolygonMenu'
import React from 'react'
import styled from 'styled-components'
import { KVAnnotation, KVCameraView, KVMeasurement, KVPolygon } from 'types'

import { CameraViewMenu } from './cameraViewMenu/CameraViewMenu'
import { MeasurementMenu } from './measurementMenu/MeasurementMenu'

const PopupMenuContainer = styled.div`
  border-radius: 16px;
  opacity: 0.8;
  background-color: rgb(60, 60, 60);
  padding: 1.25rem 0.75rem 0.75rem;
  color: white;
  line-height: 1.25rem;
  text-align: center;
  width: 15rem;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

const DraggableHandle = styled.div`
  position: absolute;
  top: 8px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 60px;
  height: 4px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.6);
`

export const MarkupPopupMenu: React.FC = () => {
  const {
    setSelectedMarkup,
    selectedMarkup,
    popupMenuStartPosition,
    setHelperTextVisible,
  } = useKestrelViewerContext()

  const selectedAnnotation =
    selectedMarkup instanceof KVAnnotation
      ? (selectedMarkup as KVAnnotation)
      : undefined

  const selectedPolygon =
    selectedMarkup instanceof KVPolygon
      ? (selectedMarkup as KVPolygon)
      : undefined

  const selectedMeasurement =
    selectedMarkup instanceof KVMeasurement
      ? (selectedMarkup as KVMeasurement)
      : undefined

  const selectedCameraView =
    selectedMarkup instanceof KVCameraView
      ? (selectedMarkup as KVCameraView)
      : undefined

  // Don't render if no popup position or no selected markup
  if (!popupMenuStartPosition || !selectedMarkup) {
    return null
  }

  // For annotations, render the new modal-style menu
  if (selectedAnnotation) {
    setHelperTextVisible(false)
    return <AnnotationMenu selectedAnnotation={selectedAnnotation} />
  }

  // For other markup types, render the original draggable popup
  return (
    <Draggable
      style={{
        left: popupMenuStartPosition.x + 'px',
        top: popupMenuStartPosition.y + 'px',
      }}>
      <PopupMenuContainer>
        <DraggableHandle />
        <CloseButton
          setSelectedMarkup={setSelectedMarkup}
          style={{
            top: '8px',
            right: '10px',
          }}
        />
        {selectedPolygon && <PolygonMenu selectedPolygon={selectedPolygon} />}
        {selectedMeasurement && (
          <MeasurementMenu selectedMeasurement={selectedMeasurement} />
        )}
        {selectedCameraView && (
          <CameraViewMenu selectedCameraView={selectedCameraView} />
        )}
      </PopupMenuContainer>
    </Draggable>
  )
}
